module.exports = __webpack_public_path__ + "static/img/200285.a6a786a1.png";